export function kebabToIconComponentName(icon: string): string {
    const parts = icon.split('-').filter(Boolean);
    if (parts.length === 0) {
        return 'Icon';
    }
    const pascal = parts
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join('');
    return `Icon${pascal}`;
}

export function tablerIconUrl(icon: string): string {
    return `${process.env.PUBLIC_URL || ''}/tabler/${icon}.svg`;
}
